import { cssThemedValue } from '@creditornot/cb-ingredients';
import { MenuItemGroup } from '@creditornot/cb-menu';
import { Popover } from '@creditornot/cb-popover';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { LanguageSelector } from 'common/components';

import MeatballButton from './MeatballButton';

const StyledMeatballButton = styled(MeatballButton)<{ iconColor?: string }>`
  line-height: 40px;
  font-size: 28px;
  width: 3rem;
  padding: 0;
  color: ${cssThemedValue('textPrimary')};
`;

const HeaderContents = () => {
  const [show, setShow] = useState(false);

  const handleTriggerClick = () => setShow(!show);
  const handleClickOutside = () => setShow(false);

  return (
    <Popover
      content={
        <MenuItemGroup title={<FormattedMessage id="navigation.languages" />}>
          <LanguageSelector onLanguageSelect={() => setShow(false)} />
        </MenuItemGroup>
      }
      onClickOutside={handleClickOutside}
      placement="bottom-end"
      show={show}
      renderArrow={false}
    >
      <StyledMeatballButton onClick={handleTriggerClick} />
    </Popover>
  );
};

export default HeaderContents;
